module.exports = __webpack_public_path__ + "static/floorplan_02-54cfab994657169049c2463fdf995a68.jpg";